import request from '@host-panel/request';
import {
  AnyTag,
  ContentType,
  Folder,
  IAdvancedFilters,
  MessagePublishedStatus,
  MessageType,
  ModeratedBy,
  Sorting,
  SpotPolicy
} from '../state/types';

type RequestPayload = {
  contentType: ContentType;
  spotId: string;
  folder: Folder;
  count: number;
  sortBy: Sorting;
  unpublishedMessagesOffset: number;
  offset: number;
  lock?: boolean;
  tag: AnyTag[];
  published: MessagePublishedStatus;
  messageType: MessageType;
  advancedFilters: Partial<IAdvancedFilters>;
  moderatedBy: ModeratedBy;
};

export type Response = {
  spot_policy: SpotPolicy;
  expiration_time: number;
  should_lock: boolean;
  folders: {
    [folder in Folder]: {
      spot_policy: string;
      count: number;
      messages: any[];
      users: {
        [userId in string]: any;
      };
      posts_metadata: {
        [postId in string]?: {
          title: string;
          url: string;
          policy: string;
        };
      };
    };
  };
};

export default function getPostItems({
  contentType = 'COMMENTS',
  spotId,
  folder,
  count,
  sortBy = Sorting.NEWEST,
  offset = 0,
  lock = false,
  tag = ['all'],
  messageType = MessageType.ALL,
  published = MessagePublishedStatus.ALL,
  advancedFilters,
  unpublishedMessagesOffset,
  moderatedBy
}: RequestPayload): Promise<Response> {
  const filteringByPublished = folder === Folder.PENDING || folder === Folder.ALL;

  return request(`/host-panel/read/${contentType.toLowerCase()}/folder/${folder}`, {
    method: 'GET',
    data: {
      spot_id: spotId,
      sort_by: sortBy,
      unpublished_offset: unpublishedMessagesOffset,
      count,
      offset,
      should_lock: lock,
      message_type: messageType,
      moderated_by: moderatedBy,
      tag: tag.join(','),
      ...(filteringByPublished && { published }),
      ...advancedFilters
    }
  });
}
